import _ from 'lodash'

export default {
  methods: {
    setErrorsFromServer (e, formRef, sharedForm = false) {
      const errors = _.get(e, 'response.data.errors', {})
      if (sharedForm) {
        this.$refs[formRef].$refs[formRef].setErrors(errors)
      } else {
        this.$refs[formRef].setErrors(errors)
      }
    }
  }
}
